import { render, staticRenderFns } from "./afterProblemDetail.vue?vue&type=template&id=11f3b085"
import script from "./afterProblemDetail.vue?vue&type=script&lang=js"
export * from "./afterProblemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports